<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="1">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="入库类型" span="1">
      <span
        v-fmtype="
          head.commodityInputOrderTypeEnum.Name == 'SaleReturnOrder'
            ? 'primary'
            : 'warning'
        "
      >
        {{ head.commodityInputOrderTypeEnum.Desc }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item
      label="客户"
      v-if="head.commodityInputOrderTypeEnum.Name == 'SaleReturnOrder'"
    >
      {{ head.customer.customerNo }}<br />
      {{ head.customer.name }}
    </el-descriptions-item>
    <el-descriptions-item
      label="联系人信息"
      span="2"
      v-if="head.commodityInputOrderTypeEnum.Name == 'SaleReturnOrder'"
    >
      {{ head.customerSupplierName + " " + head.customerSupplierPhoneNumber }}
      <br />
      {{ "联系地址：" + head.customerSupplierAddress }}
    </el-descriptions-item>
    <el-descriptions-item label="供应商" span="3" v-else>
      {{ head.supplier.name }}
    </el-descriptions-item>
    <el-descriptions-item label="关联单据" span="3">
      {{
        head.commodityInputOrderTypeEnum.Name == "SaleReturnOrder"
          ? head.relatedSaleReturnOrderHead.orderNo
          : head.relatedPurchaseOrderHead.orderNo
      }}
    </el-descriptions-item>
    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="80"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              :commodity="getCommodityOrderItem(scope.row).commoditySnapshot"
              :commoditySpec="
                getCommodityOrderItem(scope.row).commoditySpecSnapshot
              "
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySnapshot.name"
          label="商品信息"
          min-width="150"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <span style="font-size: 1.1em">{{
                getCommodityOrderItem(scope.row).commoditySnapshot.name
              }}</span
              ><br />
              {{
                "规格：" +
                getCommodityOrderItem(scope.row).commoditySpecSnapshot.specName
              }}<br />
              {{
                "分类：" +
                getCommodityOrderItem(scope.row).commoditySnapshot
                  .commodityCategory.name
              }}<br />
              {{
                "颜色：" +
                getCommodityOrderItem(scope.row).commoditySnapshot.color
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="入库数量"
          width="100"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.itemQuantity +
              getCommodityOrderItem(scope.row).commoditySnapshot.unit
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="入库详情"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.orderWareHouseList"
              :key="index"
            >
              <div>
                {{
                  "仓库：" +
                  item.wareHouse.name +
                  "，数量：" +
                  item.itemQuantity
                }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item
      label="入库数量"
      :span="head.commodityInputOrderTypeEnum.Name == 'SaleReturnOrder' ? 2 : 3"
    >
      {{ head.totalInputQuantity }}
    </el-descriptions-item>
    <el-descriptions-item
      span="1"
      v-if="head.commodityInputOrderTypeEnum.Name == 'SaleReturnOrder'"
    >
      <el-tooltip slot="label" placement="top">
        <div
          slot="content"
          style="line-height: 1.5em"
          v-html="$jsTool.needDeliveryText()"
        ></div>
        <span>
          <i class="el-icon-question"></i>
          配送标识
        </span>
      </el-tooltip>
      <span v-fmtype="head.needDelivery ? 'success' : 'warning'">{{
        head.needDelivery ? "需要配送" : "无需配送"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="纸质单据" span="3">
      <OrderImageList
        :list="head.paperOrderImageList"
        name="纸质单据图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item
      label="配送状态"
      span="2"
      v-if="
        head.orderApprovalStatusEnum.Name == 'Approval' &&
        head.commodityInputOrderTypeEnum.Name == 'SaleReturnOrder'
      "
    >
      <div class="fm-flex">
        配送状态：
        <span
          v-fmtype="
            $jsTool.getCommodityDeliverStatusType(
              head.commodityDeliverStatusEnum
            )
          "
          >{{ head.commodityDeliverStatusEnum.Desc }}</span
        >
      </div>
      <div v-if="head.commodityDeliverStatusEnum.Name != 'NoNeed'">
        <div
          class="fm-flex"
          v-if="head.commodityDeliverStatusEnum.Name != 'Unassigned'"
        >
          {{
            "配送员：" +
            head.deliveryUserList
              .map((item) => {
                return item.user.name;
              })
              .join("、")
          }}
        </div>
        <div
          class="fm-flex"
          v-if="head.commodityDeliverStatusEnum.Name == 'Complete'"
        >
          {{ head.completeDeliverTime }}
        </div>
      </div>
    </el-descriptions-item>
    <el-descriptions-item
      label="流程信息"
      :span="head.commodityInputOrderTypeEnum.Name == 'SaleReturnOrder' ? 1 : 3"
    >
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityInputOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.head
        ? this.showOrderInfo.head
        : {};
    },
    itemList() {
      return this.showOrderInfo && this.showOrderInfo.itemList
        ? this.showOrderInfo.itemList
        : [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CommodityInputOrder:NeedApproval",
        "Order:CommodityInputOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityInputOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:CommodityInputOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    getCommodityOrderItem(item) {
      return this.head.commodityInputOrderTypeEnum &&
        this.head.commodityInputOrderTypeEnum.Name == "SaleReturnOrder"
        ? item.relatedSaleReturnOrderItem.relatedSaleOrderItem
        : item.relatedPurchaseOrderItem;
    },
    async getOrderInfo() {
      let requestRes = await this.$api.commodityInputOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CommodityInputOrderInfo.vue